import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "window main" }
const _hoisted_2 = { class: "title-bar" }
const _hoisted_3 = { class: "title-bar-text" }
const _hoisted_4 = { class: "title-bar-controls" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"window-body\"><p> This app will help you to create user tokens for research participants. </p><p> When creating a token, the <code>Refresh</code> button may be used to create a fresh token. Tokens will only be saved after pressing the <code>Create</code> button. </p><p> The <code>Send Email</code> button that appears after creation, open your default email client with a message and subject prefilled. You You must only enter the e-mail of your participant to send them a token and a link to fill it in automatically. </p><p> The participant can scan the QR-code immediately after creating to log to log in to their app, avoiding the need for e-mails. You can also right-click the code to copy the image. </p><p> Do not forget to refresh the token after sending an e-mail and before dealing with the next participant. </p><p>You can always go back to the start using the close button.</p></div><div class=\"status-bar\"><div class=\"status-bar-field\">Ready</div></div>", 2)

import { Pages } from "@/Pages";
import { inject } from "vue";
import { Config } from "@/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpPage',
  emits: ["navigate"],
  setup(__props, { emit }) {


const config = inject<Config>("config") as Config;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(config).ServerName) + " User Token Generator ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          "aria-label": "Close",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('navigate', _unref(Pages).Root)))
        })
      ])
    ]),
    _hoisted_5
  ]))
}
}

})